import { FC } from 'react';

import List from 'components/reports/components/List';
import InnerWrapper from '../InnerWrapper';

const ClientsReportActiveUsers: FC = () => (
  <InnerWrapper>
    <List
      entityName="clients-report"
      entityEndpoint="clients/active-users-count"
      reportDownLoadURL="/reports/clients"
      showDownloadButton
    />
  </InnerWrapper>
);

export default ClientsReportActiveUsers;
